import PaymentMethodIndexVue from "@/views/payment-method/PaymentMethodIndex.vue";

const paymentMethod = [
  {
    path: "/payment-method",
    name: "payment-method",
    component: PaymentMethodIndexVue,
    meta: {
      layout: "default",
      role: ["superadmin","backoffice","supervisor"],
      public: false,
    },
  },
];

export default paymentMethod;
